/**
 * Weekly EOD rollup hook — stub when outbound email is not configured.
 * Scheduler/cron can call this; no-op unless EOD_WEEKLY_EMAIL env is set server-side.
 */
export interface EodWeeklyRollupInput {
  weekStart: string
  weekEnd: string
  divisionId?: string | null
}

export interface EodWeeklyRollupResult {
  sent: boolean
  reason?: string
}

/** Client-safe stub: reports whether weekly email would be configured. */
export function getEodWeeklyRollupStatus(): { configured: boolean; hint: string } {
  return {
    configured: false,
    hint: 'Weekly rollup email is not configured for this tenant. Export CSV from End of Day or use Reports.',
  }
}

export async function runEodWeeklyRollup(_input: EodWeeklyRollupInput): Promise<EodWeeklyRollupResult> {
  const status = getEodWeeklyRollupStatus()
  if (!status.configured) {
    return { sent: false, reason: status.hint }
  }
  return { sent: false, reason: 'Weekly rollup sender not yet deployed.' }
}
